
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppDateTimePicker } from '@/components';
import { useBonusLoginAdd } from '@/modules/bonus/login/model/add';
import { timeUnits } from '@/common/utils/helpers';
import { BonusLoginType } from '@/modules/bonus/login/model/mixins';
import { ROUTE_NAME_BONUS } from '@/modules/bonus/router';

export default defineComponent({
    name: ROUTE_NAME_BONUS.LOGIN.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppDateTimePicker },
    setup() {
        const { model, v$, create } = useBonusLoginAdd();

        return { v$, model, create, timeUnits, BonusLoginType };
    }
});
